module.exports = __webpack_public_path__ + "media/images/emblems/Aesch-blazon-61fdd752f6953fadda1fbcdfa043b17f.svg";